import httpClient from 'src/configs/http-client';
import { IResponse } from 'src/types';

export const getFeatureItem = async () => {
  const response = await httpClient.get<IResponse<any>>(
    `${process.env.REACT_APP_API_URL}/config-pages/home-page/public`,
  );
  return response?.data;
};
